'use client';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import {
  getTrackingUserParamsCookie,
  useTrackAppOrPwaId,
  useTrackingUserParamsStore,
} from '@/modules/userTrackingParams';
import { useGetCommonStore } from '@/store';
import { setGAConfig } from '../utils';
import { useAppEnvironment } from './useAppEnvironment';

/**
 * @description This hook is used to set the Google Analytics configuration.
 * It retrieves the tracking parameters from the user tracking store and the user ID from the common store.
 * It also determines the platform (web or PWA) and sets the Google Analytics configuration accordingly.
 */
export const useGAConfigHook = () => {
  const { stag, campaign_id, promo_id } = useTrackingUserParamsStore(
    useShallow((state) => ({
      stag: state.stag,
      campaign_id: state.campaign_id,
      promo_id: state.promo_id,
    }))
  );

  const { app_id, pwa_id } = useTrackAppOrPwaId();
  const cookieStag = getTrackingUserParamsCookie()?.stag as string | undefined;
  const useCommonStore = useGetCommonStore();

  const user_id = useCommonStore.use.user()?.id;
  const platform = useAppEnvironment();

  useEffect(() => {
    setGAConfig({
      stag: stag || cookieStag,
      campaign_id,
      promo_id,
      user_id,
      platform,
      pwa_id,
      app_id,
    });
  }, [
    stag,
    cookieStag,
    campaign_id,
    promo_id,
    user_id,
    platform,
    pwa_id,
    app_id,
  ]);
};
